"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccentTag = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/tag/tag");
const tag_utils_1 = require("@/components/common/tag/tag.utils");
/** 항목 하나를 다른 항목과 구분 짓는 강조 라벨. 강조색은 gold 하나로 고정한다. */
let AccentTag = class AccentTag extends lit_1.LitElement {
    render() {
        return (0, tag_utils_1.renderTag)('gold', this.icon);
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AccentTag.prototype, "icon", void 0);
AccentTag = __decorate([
    (0, decorators_js_1.customElement)('mm-accent-tag')
], AccentTag);
exports.AccentTag = AccentTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjZW50LXRhZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFjY2VudC10YWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQWdDO0FBQ2hDLHFEQUEyRDtBQUkzRCx1Q0FBb0M7QUFDcEMsaUVBQTZEO0FBRTdELHFEQUFxRDtBQUU5QyxJQUFNLFNBQVMsR0FBZixNQUFNLFNBQVUsU0FBUSxnQkFBVTtJQUd2QyxNQUFNO1FBQ0osT0FBTyxJQUFBLHFCQUFTLEVBQUMsTUFBTSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUNyQyxDQUFDO0NBQ0YsQ0FBQTtBQUw2QjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7dUNBQWdCO0FBRGhDLFNBQVM7SUFEckIsSUFBQSw2QkFBYSxFQUFDLGVBQWUsQ0FBQztHQUNsQixTQUFTLENBTXJCO0FBTlksOEJBQVMifQ==